import type {
  IFormConfig,
  ISectionField,
  ISectionOverrides,
} from "./types";

export const resolveSectionOverrides = (
  config: IFormConfig,
  section: "document" | "customer" | "vendor" | "items" | "totals",
): ISectionOverrides => {
  const fromSections = config.sections?.[section] ?? {};
  const aliasHidden =
    section === "customer"
      ? config.hiddenCustomerFields
      : section === "vendor"
        ? config.hiddenVendorFields
        : undefined;

  const hiddenFields = Array.from(
    new Set([...(fromSections.hiddenFields ?? []), ...(aliasHidden ?? [])]),
  );

  return {
    hiddenFields,
    extraFields: fromSections.extraFields ?? [],
    missingChips: fromSections.missingChips ?? [],
  };
};

export const sortSectionFields = (fields: ISectionField[]): ISectionField[] =>
  fields
    .map((f, i) => ({ f, i }))
    .sort((a, b) => {
      const ao = a.f.order ?? Number.POSITIVE_INFINITY;
      const bo = b.f.order ?? Number.POSITIVE_INFINITY;
      if (ao !== bo) return ao - bo;
      return a.i - b.i;
    })
    .map(({ f }) => f);
